import { Module, Mutation } from 'vuex-module-decorators'
import { navBarType } from '@/types/navBar.type'
import BaseStore from '@/store/BaseStore'

export interface App {
  activeNavBar: navBarType.NavBar
}

export type TFontFamily = 'sans-serif' | 'serif'

export type TFontSizeType = 'small' | 'normal' | 'large'

const normalFontSize = 15

@Module({
  name: 'AppStore',
  namespaced: true,
  stateFactory: true
})
export default class AppStore extends BaseStore {
  _activeNavBar = navBarType.NavBar.Top

  _fontFamily: TFontFamily = 'sans-serif'

  _fontSizeType: TFontSizeType = 'normal'

  _fontSizeExtraSmall = normalFontSize - 4

  _fontSizeSmall = normalFontSize - 2

  _fontSizeNormal = normalFontSize

  _fontSizeLarge = normalFontSize + 2

  _fontSizeExtraLarge = normalFontSize + 4

  _isEditing: boolean = false

  get fontFamily(): TFontFamily {
    return this._fontFamily
  }

  get fontFamilyIsSansSerif(): boolean {
    return this._fontFamily === 'sans-serif'
  }

  get fontSizeType(): TFontSizeType {
    return this._fontSizeType
  }

  get fontSizeTypeIsSmall() {
    return this._fontSizeType === 'small'
  }

  get fontSizeTypeIsNormal() {
    return this._fontSizeType === 'normal'
  }

  get fontSizeTypeIsLarge() {
    return this._fontSizeType === 'large'
  }

  get fontSizeExtraSmall(): number {
    return this._fontSizeExtraSmall
  }

  get fontSizeSmall(): number {
    return this._fontSizeSmall
  }

  get fontSizeNormal(): number {
    return this._fontSizeNormal
  }

  get fontSizeLarge(): number {
    return this._fontSizeLarge
  }

  get fontSizeExtraLarge(): number {
    return this._fontSizeExtraLarge
  }

  get isEditing(): boolean {
    return this._isEditing
  }

  @Mutation
  public setActiveNavBar(navBar: navBarType.NavBar) {
    this._activeNavBar = navBar
  }

  @Mutation
  public setFontFamily(fontFamily: TFontFamily) {
    this._fontFamily = fontFamily
  }

  @Mutation
  public setFontSizeType(fontSize: TFontSizeType) {
    this._fontSizeType = fontSize
    if (this._fontSizeType === 'small') {
      this._fontSizeNormal = 13
    } else if (this._fontSizeType === 'large') {
      this._fontSizeNormal = 17
    } else {
      this._fontSizeNormal = 15
    }

    this._fontSizeExtraSmall = this._fontSizeNormal - 4
    this._fontSizeSmall = this._fontSizeNormal - 2
    this._fontSizeLarge = this._fontSizeNormal + 2
    this._fontSizeExtraLarge = this._fontSizeNormal + 4
  }

  @Mutation
  public setIsEditing(bool: boolean) {
    this._isEditing = bool
  }
}
